<template>
    <div>
        <top :user="user" :collapse="collapse" :maxPage="maxPage"/>
        <navbar :permissions="permissions" v-if="permissions.length > 0" :collapse="collapse" :maxPage="maxPage"/>
        <div class="content" :class="maxPage || permissions.length == 0 ? 'content-max' : ''">
            <router-view :key="$route.fullPath" v-if="next"/>
            <div v-else>
                <v-progress-linear indeterminate>
                </v-progress-linear>
            </div>
        </div>
        <button-tags/>
    </div>
</template>
<script>
import Top from './Header'
import Navbar from './Navbar'
import ButtonTags from '../components/buttons-float/Tags'
import { mapGetters } from 'vuex'
export default {
    components: { Top, Navbar, ButtonTags },
    computed: {
        ...mapGetters([
            'user',
            'collapse',
            'maxPage',
            'permissions'
        ])
    },
    data(){
        return {
            next: false
        }
    },
    created(){
        let vue = this
        axios({url: '/me', method: 'GET' })
        .then((resp) => {
            vue.$store.dispatch('PROFILE', resp.data)
            axios({ url: '/me/permission', method: 'GET' })
            .then((resp) => {
                vue.$store.dispatch('PERMISSIONS', resp.data)
                if(resp.data.status == 'error'){
                    vue.$store.dispatch('FINISH_USER')
                    vue.$router.push({ name: 'Login' })
                }
                vue.next = true
            })
        })
        .catch((err) => {
            vue.$store.dispatch('FINISH_USER')
            vue.$router.push({ name: 'Login' })
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/layout/Content.vue